import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useOpenSlotsCount from '../../hooks/useOpenSlotsCount';
import './OpenSlotsBanner.css';

/**
 * Start-page banner that surfaces live 5v5 matches short a player.
 *
 * Only renders for registered, active members (the hook returns count=0 for
 * everyone else) and only when at least one slot is open — so it stays out of
 * the way until there's actually a match to jump into. Clicking it routes to
 * the "Öppna platser" browse page where the claim happens.
 */
export default function OpenSlotsBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { count } = useOpenSlotsCount();

  if (count <= 0) return null;

  return (
    <button
      type="button"
      className="open-slots-banner"
      onClick={() => navigate('/open-slots')}
    >
      <span className="open-slots-banner-dot" />
      <span className="open-slots-banner-text">
        <strong>{t('openSlots.bannerTitle', { count })}</strong>
        <small>{t('openSlots.bannerDesc')}</small>
      </span>
      <span className="open-slots-banner-cta">{t('openSlots.bannerCta')}</span>
    </button>
  );
}
